import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { components } from 'react-select';

const SingleValue = (_a) => {
    var { selectProps, children } = _a, rest = __rest(_a, ["selectProps", "children"]);
    const { value } = selectProps;
    const valueLabel = useMemo(() => {
        if (value) {
            const { component: Component, label } = value;
            if (Component) {
                return jsx(Component, { label: label });
            }
        }
        return children;
    }, [value, children]);
    return (jsx(components.SingleValue, Object.assign({ selectProps: selectProps }, rest, { children: valueLabel })));
};

export { SingleValue as default };
//# sourceMappingURL=SingleValue.js.map
